import * as userSelectors from './userSelectors.js';
import * as uiSelectors from './uiSelectors.js';
import * as settingsSelectors from './settingsSelectors.js';
import * as workflowSelectors from './workflowSelectors.js';
import * as jobsSelectors from './jobsSelectors.js';
import * as querySelectors from './querySelectors.js';
import * as embeddedSelectors from './embeddedSelectors.js';
import * as turnkeySelectors from './turnkeySelectors.js';
import * as serviceSelectors from './serviceSelectors.js';
import * as operationsSelectors from './operationsSelectors.js';
import * as monitoringSelectors from './monitoringSelectors.js';

export const selectors = {
  ...querySelectors,
  ...userSelectors,
  ...uiSelectors,
  ...settingsSelectors,
  ...workflowSelectors,
  ...jobsSelectors,
  ...embeddedSelectors,
  ...turnkeySelectors,
  ...serviceSelectors,
  ...operationsSelectors,
  ...monitoringSelectors
};

export default selectors;
